import { useTranslation } from 'react-i18next';
import { ExpenseStatus } from '@optiflow/types';
import { Badge } from '@/components/ui/Badge';

type Tone = 'neutral' | 'success' | 'warning' | 'danger' | 'brand';

const STATUS_TONES: Record<ExpenseStatus, Tone> = {
  [ExpenseStatus.POSTED]: 'success',
  [ExpenseStatus.VOIDED]: 'neutral',
};

/**
 * What an expense is, in words.
 *
 * Posted carries a success tone rather than the brand one a supplier invoice gets: an expense is
 * money already spent and settled, not an obligation the business has taken on. Every badge says
 * what it means in text, so none of this depends on colour.
 */
export function ExpenseStatusBadge({ status }: { status: ExpenseStatus }) {
  const { t } = useTranslation();
  return (
    <Badge tone={STATUS_TONES[status] ?? 'neutral'}>{t(`expenses.status.${status}`)}</Badge>
  );
}

/** A category or supplier that is no longer in use. Still readable, still on old documents. */
export function InactiveBadge({ label }: { label?: string }) {
  const { t } = useTranslation();
  return <Badge tone="warning">{label ?? t('expenses.inactive')}</Badge>;
}
